/**
 * Сохранение настроек в localStorage
 */

const KEY_SOUND = 'vortex_sound';
const KEY_LAST_BET = 'vortex_last_bet';
const KEY_LANG = 'vortex_lang';
const KEY_HISTORY = 'vortex_history';
const MAX_HISTORY = 50;

export function getSoundEnabled(): boolean {
  try {
    const v = localStorage.getItem(KEY_SOUND);
    return v === null ? true : v === '1';
  } catch {
    return true;
  }
}

export function setSoundEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY_SOUND, enabled ? '1' : '0');
  } catch {
    // ignore
  }
}

export function getLastBet(): number | null {
  try {
    const v = localStorage.getItem(KEY_LAST_BET);
    return v === null ? null : parseFloat(v);
  } catch {
    return null;
  }
}

export function setLastBet(bet: number): void {
  try {
    localStorage.setItem(KEY_LAST_BET, String(bet));
  } catch {
    // ignore
  }
}

export type Lang = 'ru' | 'en';

export function getLang(): Lang {
  try {
    const v = localStorage.getItem(KEY_LANG);
    if (v === 'ru' || v === 'en') return v;
    return 'en';
  } catch {
    return 'en';
  }
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem(KEY_LANG, lang);
  } catch {
    // ignore
  }
}

export interface RoundHistoryEntry {
  bet: number;
  result: 'cashout' | 'skull';
  payout: number;
  multiplier: number;
  timestamp: number;
}

export function getHistory(): RoundHistoryEntry[] {
  try {
    const v = localStorage.getItem(KEY_HISTORY);
    if (!v) return [];
    const arr = JSON.parse(v) as RoundHistoryEntry[];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function pushHistory(entry: RoundHistoryEntry): void {
  try {
    const arr = getHistory();
    arr.unshift(entry);
    if (arr.length > MAX_HISTORY) arr.length = MAX_HISTORY;
    localStorage.setItem(KEY_HISTORY, JSON.stringify(arr));
  } catch {
    // ignore
  }
}
